// client/src/features/quote-builder/TemplateSelectionModal.js
import React, { useState } from 'react';

function TemplateSelectionModal({ isOpen, onClose, onSelectTemplate, onAddCustomSection, templates }) {
  // Pass template ID to parent when selecting a template
  const handleSelectTemplateClick = (templateId) => {
    // Only pass ID; parent (QuoteFormPage) will fetch full details with items
    if (typeof onSelectTemplate === 'function') {
      onSelectTemplate(templateId, {});
    }
  };

  // No dimensions passed when adding a custom empty section
  const handleAddCustomSectionClick = () => {
    if (typeof onAddCustomSection === 'function') {
      onAddCustomSection({});
    }
  };

  // Utility function to strip HTML and truncate to first line or a short snippet
  const getDescriptionSnippet = (description) => {
    if (!description) return 'No description';
    // Remove HTML tags
    const plainText = description.replace(/<[^>]*>/g, '');
    // Truncate to first line or a reasonable character limit
    const firstLine = plainText.split('\n')[0];
    return firstLine.length > 100 ? firstLine.substring(0, 100) + '...' : firstLine;
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto p-6 relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 focus:outline-none"
          aria-label="Close modal"
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path></svg>
        </button>
        <h2 className="text-2xl font-bold text-primary-700 mb-6 border-b pb-4 border-gray-200">
          Add Section to Quote
        </h2>
        
        <div className="space-y-4">
          <h3 className="text-xl font-semibold text-gray-800">Select a Template</h3>
          <div className="border border-gray-200 rounded-lg p-4 bg-gray-50">
            <h3 className="font-semibold text-lg text-gray-900 mb-2">Add Custom Section</h3>
            <button
              onClick={handleAddCustomSectionClick}
              className="px-4 py-2 bg-gray-600 text-white text-sm font-medium rounded-md hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-gray-500"
            >
              Create Empty Section
            </button>
        </div>
          {templates.length === 0 ? (
            <p className="text-gray-500 text-center py-4 border border-dashed border-gray-300 rounded-lg">
              No templates available. Create some in the Templates section!
            </p>
          ) : (
            templates.map(template => (
              <div key={template.id} className="border border-gray-200 rounded-lg p-4 hover:bg-blue-50 transition duration-150 ease-in-out">
                <h3 className="font-semibold text-lg text-gray-900">{template.name}</h3>
                <p className="text-sm text-gray-600 mb-2 truncate" title={getDescriptionSnippet(template.description)}>{getDescriptionSnippet(template.description)}</p>
                <button
                  onClick={() => handleSelectTemplateClick(template.id)} // Pass template.id
                  className="px-4 py-2 bg-primary-600 text-white text-sm font-medium rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-primary-500"
                >
                  Add This Template
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}

export default TemplateSelectionModal;
